import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/redken-logo.webp'


const _hoisted_1 = { class: "flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Redken logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-bold" }, "Email:", -1)
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-bold" }, "Vorname:", -1)
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-bold" }, "Name:", -1)
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "grid mt-5 pt-3 border-top-1" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "col-6 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_breadcrumbs = _resolveComponent("breadcrumbs")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Menubar = _resolveComponent("Menubar")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createVNode(_component_Menubar, { class: "p-3" }, {
      start: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args)))
          }, _hoisted_3),
          _createVNode(_component_Button, {
            icon: "pi pi-fw pi-bars text-white",
            class: "p-button-text p-button-rounded ml-5",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.syncedShowAside = !_ctx.syncedShowAside))
          }),
          _createVNode(_component_breadcrumbs)
        ])
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-fw pi-user",
          class: "p-button-rounded p-button-raised",
          onClick: _ctx.toggleProfilePanel
        }, null, 8, ["onClick"]),
        _createVNode(_component_OverlayPanel, {
          ref: "profilePanel",
          style: {"width":"400px"},
          breakpoints: { '960px': '75vw' }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user.email), 1),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.user.firstName), 1),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.user.lastName), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Button, {
                  title: _ctx.$t('general.user_profile'),
                  icon: "pi pi-fw pi-user-edit",
                  class: "p-button-rounded p-button-info p-button-raised",
                  onClick: _ctx.goToEditProfile
                }, null, 8, ["title", "onClick"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Button, {
                  title: _ctx.$t('auth.logout'),
                  icon: "pi pi-fw pi-power-off",
                  class: "p-button-rounded p-button-danger p-button-raised",
                  onClick: _ctx.logout
                }, null, 8, ["title", "onClick"])
              ])
            ])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    })
  ]))
}